module.exports = __webpack_public_path__ + "img/req2.a0d471a9.png";